module.exports = __webpack_public_path__ + "static/media/datu7.eb403033.png";